var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.47031 8.47031C8.76094 8.175 9.23906 8.175 9.52969 8.47031L12 10.9406L14.4703 8.47031C14.7609 8.175 15.2391 8.175 15.5297 8.47031C15.825 8.76094 15.825 9.23906 15.5297 9.52969L13.0594 12L15.5297 14.4703C15.825 14.7609 15.825 15.2391 15.5297 15.5297C15.2391 15.825 14.7609 15.825 14.4703 15.5297L12 13.0594L9.52969 15.5297C9.23906 15.825 8.76094 15.825 8.47031 15.5297C8.175 15.2391 8.175 14.7609 8.47031 14.4703L10.9406 12L8.47031 9.52969C8.175 9.23906 8.175 8.76094 8.47031 8.47031ZM24 12C24 18.6281 18.6281 24 12 24C5.37188 24 0 18.6281 0 12C0 5.37188 5.37188 0 12 0C18.6281 0 24 5.37188 24 12ZM12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5Z",
    fill: "#FF3E3A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.525dc7286ee26bd0c1116812160c3343.svg";
export { ForwardRef as ReactComponent };